export const HIGH_TIER_FEE = 30
export const MEDIUM_TIER_FEE = 20
export const LOW_TIER_FEE = 10
